import { render, staticRenderFns } from "./BindPaper.vue?vue&type=template&id=50bfb211&scoped=true&"
import script from "./BindPaper.vue?vue&type=script&lang=js&"
export * from "./BindPaper.vue?vue&type=script&lang=js&"
import style0 from "./BindPaper.vue?vue&type=style&index=0&id=50bfb211&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfb211",
  null
  
)

export default component.exports